import {
  IFAQ,
  IFAQGuest,
  IFAQAll,
  ICombination,
  ICombinationGuest,
  ISectionAll,
  ISection,
  ISectionGuest,
  IFAQFileAll,
  IFAQFile,
  IFAQFileGuest
} from "@/types/SPTypes.tsx";

const isIFAQAll = (value: any): value is IFAQAll => {
  return (
    typeof value?.question === "string" &&
    typeof value?.answer === "string" &&
    typeof value?.active === "boolean" &&
    typeof value?.FAQTitle === "string"
  );
};

// if user is logged in (logp)
export const isIFAQ = (value: any): value is IFAQ => {
  return (
    isIFAQAll(value) &&
    value?.section !== undefined &&
    value?.questionType !== undefined &&
    value?.clientTypes !== undefined
  );
};

// If the user is not logged in (logistikportalen)
export const isIFAQGuest = (value: any): value is IFAQGuest => {
  return (
    isIFAQAll(value) &&
    typeof value?.sectionTitle === "string" &&
    typeof value?.questionTypeTitle === "string" &&
    typeof value?.clientTypesTitle === "string" &&
    typeof value?.vsdlId === "number"
  );
};

export const isCombination = (value: any): value is ICombination => {
  return (
    value?.section !== undefined &&
    value?.clientType !== undefined &&
    value?.questionType !== undefined
  );
};

export const isGuestCombination = (value: any): value is ICombinationGuest => {
  return (
    typeof value?.sectionTitle === "string" &&
    typeof value?.questionTypeTitle === "string" &&
    typeof value?.clientTypeTitle === "string"
  );
};

// ISection

const isISectionAll = (value: any): value is ISectionAll => {
  return (
    typeof value?.sectionTitle === "string" &&
    typeof value?.sectionType === "string" &&
    typeof value?.active === "boolean"
  );
};

export const isISection = (value: any): value is ISection => {
  return isISectionAll(value) && value.vsdlId === undefined;
};

export const isISectionGuest = (value: any): value is ISectionGuest => {
  return (
    isISectionAll(value) &&
    value?.connectedSections === undefined &&
    value?.connectedSectionsTitles !== undefined &&
    value?.vsdlId !== undefined
  );
};

// IFAQFile

export const isIFAQFileAll = (value: any): value is IFAQFileAll => {
  return (
    value != null &&
    typeof value.Title === "string" &&
    (typeof value.belongsToFAQ === "number" ||
      (typeof value.belongsToFAQ === "object" && value.belongsToFAQ !== null))
  );
};

export const isIFAQFile = (value: any): value is IFAQFile => {
  return (
    isIFAQFileAll(value) &&
    typeof value.belongsToFAQ === "object" &&
    value.belongsToFAQ !== null &&
    value.vsdlId === undefined
  );
};

export const isIFAQFileGuest = (value: any): value is IFAQFileGuest => {
  return (
    isIFAQFileAll(value) &&
    typeof value.belongsToFAQ === "number" &&
    typeof value.vsdlId === "number"
  );
};
